import React from "react";
import { Route, Routes } from "react-router-dom";

// Components
import { EnhancedPuppyHome, PuppyProfileContainer } from "../Components";

export const TrainedPuppiesForSale = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<EnhancedPuppyHome />} />
        <Route path="/:profilePath" element={<PuppyProfileContainer />} />
      </Routes>
    </>
  );
};
